import React, { useEffect, useMemo, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
  LoadingDialog,
} from "../../../_metronic/_partials/controls";
import { NewOrderDialog } from "./NewOrderDialog";
import { ManualOrdersTable } from "./ManualOrdersTable";
import * as manualOrdersCrud from './manualOrdersCrud'
import { errorMsg, successMsg } from "../Global/helpers";
import { EditOrderDialog } from "./EditOrderDialog";
import Swal from "sweetalert2";


export function ManualOrdersCard() {
    const [showNewOrderDialog, setShowNewOrderDialog] = useState(false)
    const [showEditOrderDialog, setShowEditOrderDialog] = useState(false)
    const [manualOrderForEdit, setManualOrderForEdit] = useState({})
    const [readOnlyOrder, setReadOnlyOrder] = useState(false)
    const [queryParams, setQueryParams] = useState({pageNumber:1, pageSize:10})
    
    const [entities, setEntities] = useState([])
    const [totalCount, setTotalCount] = useState(0)
    // Bloquea la pantalla mientras se envía una orden a WC o se elimina (tardan
    // unos segundos y sin esto se puede clickear otras filas/acciones en el medio)
    const [sendingToWC, setSendingToWC] = useState(false)
    const [deleting, setDeleting] = useState(false)

    const fetchOrders = async()=>{
        try{
            const resp = await manualOrdersCrud.getManualOrders(queryParams)
            setEntities(resp?.data?.results || [])
            setTotalCount(resp?.data?.count || 0)
            console.log(resp)
        }
        catch(err){
            console.log(err)
        }
    }

    const editOrder = (row, readOnly = false)=>{
        setManualOrderForEdit(row)
        setReadOnlyOrder(readOnly)
        setShowEditOrderDialog(true)
    }
    
    const sendToWC = async(row)=>{
        Swal.fire({
            title: 'Confirmación',
            text: `Confirma el envío de la órden ${row.id} a Woocommerce?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sí',
            confirmButtonColor: '#0A9E95',
            cancelButtonText:'No'
            }).then(async res=>{
                if (res.isConfirmed) {
                    try {
                        setSendingToWC(true)
                        const resp = await manualOrdersCrud.updateStatusManualOrder(row.id, {status:"Pendiente WC"});
                        // OJO: el interceptor global de axios (Aside.js) NO rechaza en error,
                        // por eso en caso de falla 'resp' viene undefined en vez de tirar excepción.
                        if (resp && resp.data && resp.data.message) {
                            successMsg(`La órden se envió correctamente`);
                        } else {
                            errorMsg(`No se pudo enviar la orden a Woocommerce. Revisá el pedido e intentá de nuevo.`);
                        }
                    } catch (err) {
                        console.log(err);
                        errorMsg(`No se pudo enviar la orden a Woocommerce. Revisá el pedido e intentá de nuevo.`);
                    } finally {
                        // El control vuelve recién con la lista actualizada
                        await fetchOrders()
                        setSendingToWC(false)
                    }
                }
        })
    }

    const deleteOrder = (row) =>{
        Swal.fire({
            title: 'Confirmación',
            text: `Va a eliminar la órden ${row.id}, confirma?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sí',
            confirmButtonColor: '#0A9E95',
            cancelButtonText:'No'
            }).then(async res=>{
                if (res.isConfirmed) {
                    try {
                        setDeleting(true)
                        const resp = await manualOrdersCrud.deleteManualOrder(row.id);
                        if (resp && resp.data && resp.data.message) {
                            successMsg(`La órden se eliminó correctamente`);
                        } else {
                            errorMsg(`No se pudo eliminar la órden. Intentá de nuevo.`);
                        }
                    } catch (err) {
                        console.log(err);
                        errorMsg(`No se pudo eliminar la órden. Intentá de nuevo.`);
                    } finally {
                        // El control vuelve recién con la lista actualizada
                        await fetchOrders()
                        setDeleting(false)
                    }
                }
        })
    }

    const onSave = async(orderData)=>{
        try{
            let resp = await manualOrdersCrud.createManualOrder(orderData)
            if (resp && resp.data && resp.data.message) {
                successMsg(`Se creó el pedido`);
                setShowNewOrderDialog(false)
                fetchOrders()
            } else {
                errorMsg("No se pudo crear el pedido. Revisá los datos e intentá de nuevo.")
            }
        }
        catch(err){
            console.log(err)
            errorMsg("Error al guardar pedido")
        }
    }

    const onSaveUpdate = async(orderData)=>{
        try{
            let resp = await manualOrdersCrud.updateManualOrder(orderData)
            if (resp && resp.data && resp.data.message) {
                successMsg(`Se actualizó el pedido`);
                setShowEditOrderDialog(false)
                fetchOrders()
            } else {
                errorMsg("No se pudo actualizar el pedido. Revisá los datos e intentá de nuevo.")
            }
        }
        catch(err){
            console.log(err)
            errorMsg("Error al guardar pedido")
        }
    }

    useEffect(()=>{
        if(queryParams.pageNumber)
            fetchOrders()
    }, [queryParams])

    return (

        <Card>

            <LoadingDialog isLoading={sendingToWC} text="Enviando a Woocommerce..." />
            <LoadingDialog isLoading={deleting} text="Eliminando pedido..." />

            <NewOrderDialog show={showNewOrderDialog} onHide={()=>setShowNewOrderDialog(false)} onSave={onSave}/>
            <EditOrderDialog show={showEditOrderDialog} onHide={()=>setShowEditOrderDialog(false)} onSave={onSaveUpdate} manualOrderForEdit={manualOrderForEdit} readOnly={readOnlyOrder}/>

            <CardHeader title="Lista de Pedidos Manuales">
                <CardHeaderToolbar>
                {/* <button
                    type="button"
                    className="btn btn-primary"
                    onClick={()=>{setShowNewOrderDialog(true)}}
                >
                    Nuevo pedido
                </button> */}
                </CardHeaderToolbar>
            </CardHeader>
            <CardBody>
                <button type="button" className="btn btn-primary float-right mb-10" onClick={()=>setShowNewOrderDialog(true)}> Nuevo pedido</button>
                <ManualOrdersTable entities={entities} totalCount={totalCount} editOrder={editOrder} deleteOrder={deleteOrder} sendToWC={sendToWC}
                    busy={sendingToWC || deleting} queryParams={queryParams} setQueryParams={setQueryParams}/>
            </CardBody>
        </Card>
    );
}
